import { Filters } from "./types";
import { GetInsuranceDoctorsFilterDto } from "@apiModels/Insurance/GetInsuranceDoctorsFilterDto.csharp";

export const mapFiltersToRequest = (filters: Filters, getFavorites = false) => {
  const request: GetInsuranceDoctorsFilterDto = {};
  const { service, specialization, locations, keywords } = filters;

  if (specialization) {
    request.specializationId = specialization.id;
  }

  if (service) {
    request.serviceId = service.id;
  }

  if (locations) {
    locations.map((location) => {
      if (location.isLocation) {
        request.locationIds = [...(request.locationIds ?? []), location.id];
        return;
      }

      request.centerIds = [...(request.centerIds ?? []), location.id];
    });
  }

  if (keywords) {
    keywords.map((keyword) => {
      request.keywords = [...(request.keywords ?? []), keyword.name];
    });
  }

  if (getFavorites) {
    request.filterFavourite = true;
  }

  return request;
};
